import {ClientAlertForm} from "../../types/clients";
import {useEffect, useState} from "react";
import * as React from "react";

export default NumberInputWithCommas;

function NumberInputWithCommas(props: {
  value: string;
  alert?: ClientAlertForm; // optional: if provided, handles alert changes
  onChange: (changeType: ClientAlertForm | string, rawValue: string) => void; // callback for either limits or alerts
  required?: boolean;
  minLength?: string;
  maxLength?: string;
}) {
  const [formattedValue, setFormattedValue] = useState("");

  // formats numbers with commas (removes for parsing, then re-adds)
  const formatNumber = (value: string): string => {
    if (!value) return "";
    const wholeNumberValue = value.replace(/[^0-9]/g, ""); // remove decimals
    const number = parseInt(wholeNumberValue, 10);
    return isNaN(number) ? "" : new Intl.NumberFormat().format(number); // Add commas
  };

  // Update display formatting when value changes
  useEffect(() => {
    setFormattedValue(formatNumber(props.value));
  }, [props.value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const rawInputValue = event.target.value.replace(/,/g, ""); // Remove commas
    const wholeNumberValue = rawInputValue.replace(/[^0-9]/g, ""); // Remove decimals
    const parsedValue = parseInt(wholeNumberValue, 10);

    setFormattedValue(formatNumber(wholeNumberValue)); // Format with commas
    props.onChange(wholeNumberValue, wholeNumberValue); 

    if (parsedValue === 0 && props.minLength === '1') {
      event.target.setCustomValidity("Value must be greater than or equal to 1");
    } else {
      event.target.setCustomValidity("");
    }

    if (isNaN(Number(rawInputValue))) {
      return;
    }

    if (isNaN(parsedValue)) {
      setFormattedValue("");
      props.onChange("", "");
    } else {
      setFormattedValue(formatNumber(wholeNumberValue)); // Format with commas for UI
      props.onChange(rawInputValue, parsedValue.toString()); // Pass the raw number back without commas
    }
  };

  return (
    <input
      type="text"
      value={formattedValue}
      onChange={handleChange}
      onInvalid={(event) => {
        if ((event.target as HTMLInputElement).value === "0") {
          (event.target as HTMLInputElement).setCustomValidity("Value must be greater than or equal to 1");
        }
      }}
      onBlur={(event) => {
        if (
          (event.target as HTMLInputElement).value === "0" &&
          props.minLength === '1'
        ) {
          event.target.setCustomValidity("Value must be greater than or equal to 1");
        } else {
          event.target.setCustomValidity(""); 
        }
      }}
      className="inline-block input no-margin-bottom text-right"
      required={props.required}
      maxLength={props.maxLength ? parseInt(props.maxLength, 10) : undefined}
      minLength={props.minLength ? parseInt(props.minLength, 10) : undefined}
    />
  );
}
